module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/bath-7567f988b7c637183bd3d053e800bf0c.webp";